import { render, staticRenderFns } from "./PayslipsLineItemsDataTable.vue?vue&type=template&id=57479401"
import script from "./PayslipsLineItemsDataTable.vue?vue&type=script&lang=js"
export * from "./PayslipsLineItemsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports